import { Component } from '@angular/core';
import { TourismEventsComponent } from '@/tourism-events/tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';

@Component({
	selector: 'app-tourism-events-wash',
	template: `<app-tourism-events-full [category]="CategoryEvent.WASH"></app-tourism-events-full>`,
})
export class TourismEventsWashComponent extends TourismEventsComponent {
	readonly CategoryEvent = CategoryEvent;
}
